import { http } from '../shared/api';

const inFlightRequests = new Map();

const requestKey = (endpoint, fiscalYear) => (
  `${endpoint}?fiscal_year=${fiscalYear ?? 'latest'}`
);

async function getScreen(endpoint, fiscalYear, config = {}) {
  const key = requestKey(endpoint, fiscalYear);
  if (!inFlightRequests.has(key)) {
    const params = { ...(config.params || {}) };
    if (fiscalYear !== undefined && fiscalYear !== null) {
      params.fiscal_year = Number(fiscalYear);
    }
    const { force: _force, ...requestConfig } = config;
    const request = http.get(endpoint, { ...requestConfig, signal: undefined, params })
      .finally(() => inFlightRequests.delete(key));
    inFlightRequests.set(key, request);
  }
  const response = await inFlightRequests.get(key);
  if (config.signal?.aborted) throw new DOMException('Aborted', 'AbortError');
  return response;
}

export const getDashboardEmissions = (fiscalYear, config) => (
  getScreen('/api/emissions/dashboard', fiscalYear, config)
);

export const getScope1Emissions = (fiscalYear, config) => (
  getScreen('/api/emissions/scope-1', fiscalYear, config)
);

export const getScope2Emissions = (fiscalYear, config) => (
  getScreen('/api/emissions/scope-2', fiscalYear, config)
);

export const getScope3Emissions = (fiscalYear, config) => (
  getScreen('/api/emissions/scope-3', fiscalYear, config)
);


export const getYearlyEmissionOverview = (config = {}) => (
  http.get('/api/emissions/yearly-overview', config)
);

export const getResultSummary = (body, config) => http.post(
  '/api/emissions/result-summary',
  body,
  config,
);
